import { useState } from "react";

export interface ContactFormData {
  email: string;
  mobile: string;
  message: string;
}

export const useContactUs = () => {
  const [loading, setLoading] = useState(false);

  // Mock for now → replace with real API in the future
  const sendMessage = async (data: ContactFormData) => {
    setLoading(true);
    try {
      await new Promise((res) => setTimeout(res, 1000)); // mock delay
      return { success: true };
    } catch (err) {
      console.error(err);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    sendMessage,
  };
};
